/** @format */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import SimCard from '@material-ui/icons/SimCard';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from '../../components/Heading/CardHeaderExt';

import CustomButtom from '../../components/CustomButtons/ButtonExt';
import CancelTextButton from '../../components/Buttons/CancelTextButtons';

import simcardStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../components/Translate/I18n';
import TariffSelectComponent from '../../components/Adescom/TariffSelectApi';
import { SimCardEntity, SimCardStatus } from '../../modules/simcard/Entity';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { history } from '../../core/history';
import InputFormRest from '../../components/Form/InputFormRest';
import CheckBoxFormRest from '../../components/Form/CheckBoxFormRest';
import DatePickerFormRest from '../../components/Form/DatePickerFormRest';
import MsisdnPoolChooseDialog from '../msisdn-pools/Dialog/MsisdnPoolChooseDialog';
import IccidPoolChooseDialog from '../iccid-pools/Dialog/IccidPoolChooseDialog';
import { clientsActions, clientsConstants } from '../../modules/clients/actions';
import { simCardActions, simCardConstants } from '../../modules/simcard/actions';

class SimCardAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            entity: SimCardEntity,
            entityStatus: SimCardStatus,
            cancelReturnUri: this.props.match.params.id,

            openMsisdn: false,
            openIccid: false,
            client: this.props.handleGetObject('clientObject'),
        };
        if (this.props.handleGetObject('clientObject') === null) {
            this.init(this.props.match.params.id);
        }
        this.props.handleSetBrandText('');
    }

    init = (clientUri) => {
        const { dispatch } = this.props;
        dispatch(clientsActions.get(FormGeneralHelper.getByUri('/' + clientUri), clientsConstants.CLIENTS_ITEM));
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.success === true) {
            this.returnClientList();
            return false;
        }
        if (nextProps.type !== clientsConstants.CLIENTS_ITEM && this.state.client === null) {
            return false;
        }
        if (nextProps.type === clientsConstants.CLIENTS_ITEM && this.state.client === null) {
            this.setState((prevState) => ({ client: nextProps.item, entity: { ...prevState.entity, clientId: nextProps.item.id } }));
        }
        return true;
    }

    returnClientList = () => {
        if (this.state.cancelReturnUri) {
            history.push(FormGeneralHelper.getRouteUrl('/clients-edit/' + this.state.cancelReturnUri));
        } else {
            history.push(FormGeneralHelper.getRouteUrl('/clients-list'));
        }
    };

    callBackSetMsisdn = (value) => {
        this.setState(
            (prevState) => ({
                entity: {
                    ...prevState.entity,
                    msisdn: value.msisdn,
                },
            }),
            this.closeMsisdn
        );
    };

    closeMsisdn = () => {
        this.setState((prevState) => ({
            openMsisdn: false,
        }));
    };

    openGetMsisdn = () => {
        this.setState((prevState) => ({
            openMsisdn: true,
        }));
    };

    openGetIccid = () => {
        this.setState((prevState) => ({
            openIccid: true,
        }));
    };

    closeIccid = () => {
        this.setState((prevState) => ({
            openIccid: false,
        }));
    };

    callBackSetIccid = (value) => {
        this.setState(
            (prevState) => ({
                entity: {
                    ...prevState.entity,
                    iccid: value.iccid,
                },
            }),
            this.closeIccid
        );
    };

    handleSubmit = (e) => {
        const { dispatch } = this.props;
        FormGeneralHelper.handleSubmit(this, e, this.submitCallBackDispatch, false, dispatch);
    };

    submitCallBackDispatch() {
        const { dispatch } = this.props;
        dispatch(simCardActions.post(FormGeneralHelper.getUrl('/sim-cards'), this.state.entity, simCardConstants.SIM_CARD_ADD));
    }

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    selectFunc = (e, stateName, require) => {
        FormGeneralHelper.selectFunc(this, e, stateName, require);
    };

    render() {
        const { classes } = this.props;
        const { client, entity, entityStatus } = this.state;
        if (client) {
            return (
                <form onSubmit={this.handleSubmit} key="sim_card_form">
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardHeader icon={<SimCard />} trans="simcard:add.add_sim_card" />
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputFormRest
                                                onClick={this.openGetMsisdn}
                                                classes={classes}
                                                callback={this.change}
                                                stateName="msisdn"
                                                stateObjectState={entityStatus.msisdn}
                                                typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                                typeField={FormGeneralHelper.TYPE_TEXT}
                                                displayFieldName="simcard:add.msisdn"
                                                vMax={256}
                                                vMin={-1}
                                                required={true}
                                                value={entity.msisdn}
                                                helpText="simcard:general.msisdn"
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputFormRest
                                                onClick={this.openGetIccid}
                                                classes={classes}
                                                callback={this.change}
                                                stateName="iccid"
                                                stateObjectState={entityStatus.iccid}
                                                typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                                typeField={FormGeneralHelper.TYPE_TEXT}
                                                displayFieldName="simcard:add.iccid"
                                                vMax={256}
                                                vMin={-1}
                                                required={true}
                                                value={entity.iccid}
                                                helpText="simcard:general.iccid"
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <CheckBoxFormRest checked={entity.autoactivationdate} label={'simcard:add.activation_date'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <DatePickerFormRest
                                                placeholder="simcard:add.activation_date_choose"
                                                helpText="simcard:add.activation_date_choose"
                                                callback={() => {}}
                                                typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                stateName={'autoactivationdate'}
                                                required={false}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TariffSelectComponent
                                                callbackSelect={this.selectFunc}
                                                tariffIdState={entityStatus.tariffId}
                                                tariffIdSelected={entity.tariffId}
                                                stateName="tariffId"
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={4}>
                            <CustomButtom type="submit">
                                <I18n trans="simcard:add.save_sim_card" />
                            </CustomButtom>
                            <CancelTextButton callback={this.returnClientList} />
                        </GridItem>
                    </GridContainer>
                    <MsisdnPoolChooseDialog
                        platformResellerId={this.state.client.platformResellerId}
                        callbackClose={this.closeMsisdn}
                        callBackSetMsisdn={this.callBackSetMsisdn}
                        open={this.state.openMsisdn}
                    />
                    <IccidPoolChooseDialog
                        platformResellerId={this.state.client.platformResellerId}
                        callBackClose={this.closeIccid}
                        callBackSetIccid={this.callBackSetIccid}
                        open={this.state.openIccid}
                    />
                </form>
            );
        } else {
            return <div>Loading...</div>;
        }
    }
}

SimCardAdd.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    const { simCardReducers, clientsReducers } = state;
    if (simCardReducers.type === simCardConstants.SIM_CARD_ADD) {
        return {
            type: simCardReducers.type,
            success: simCardReducers.success,
        };
    }
    if (clientsReducers.type === clientsConstants.CLIENTS_ITEM) {
        return {
            type: clientsConstants.CLIENTS_ITEM,
            item: clientsReducers.item,
        };
    }
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(simcardStyle));
const Enhance = enhance(SimCardAdd);
export default Enhance;
